import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export function getCmsBody(slug){
  return function(dispatch) {
    dispatch({type: 'FETCHING',});
    axios.get(apiUrl+'cms/pages/'+slug
      ).then((response) => {
          dispatch({type: 'GET_CMS_FULFILLED', payload: response.data,});
      }).catch((err) =>{
          dispatch({type: 'GET_CMS_REJECTED', payload: err,})
    })
  }
}
export function getCMSList(){
  return function(dispatch){
    axios.get(apiUrl+'cms/pages').then((response) => {
      dispatch({type: 'GET_CMS_LIST_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_CMS_LIST_REJECTED', payload: err,})
    })
  }
}
export function getMainBannerList(){
  return function(dispatch){
    dispatch({type: 'GET_MAIN_BANNER_LIST_FETCHING',});
    axios.get(apiUrl+'promotion/main').then((response) => {
      dispatch({type: 'GET_MAIN_BANNER_LIST_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_MAIN_BANNER_LIST_REJECTED', payload: err,})
    })
  }
}
export function getFeaturedBannerList(){
  return function(dispatch){
    axios.get(apiUrl+'promotion/featured').then((response) => {
      dispatch({type: 'GET_FEATURED_BANNER_LIST_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_FEATURED_BANNER_LIST_REJECTED', payload: err,})
    })
  }
}
export function putBannerClick(token, id, url){
  return function(dispatch){
    axios.put(apiUrl+'promotions/click', {token, id,}).then((response) => {
      dispatch({type: 'PUT_BANNER_CLICK_FULFILLED', payload: response.data,})
      window.location.href=url;
    }).catch((err) =>{
      dispatch({type: 'PUT_BANNER_CLICK_REJECTED', payload: err,})
      window.location.href=url;
    })
  }
}
export function getHomepageBlocks(){
  return function(dispatch){
    dispatch({type: 'GET_HOMEPAGE_BLOCKS_FETCHING',});
   axios.get(apiUrl+'cms/blocks/HomeWelcome,HomeWelcomeOut,HomeSocial,HomeShoppers,HomeShippingEase,HomeStore,HomeStoreOut?variable=1').then((response) => {
     dispatch({type: 'GET_HOMEPAGE_BLOCKS_FULFILLED', payload: response.data,})
   }).catch((err) =>{
     dispatch({type: 'GET_HOMEPAGE_BLOCKS_REJECTED', payload: err,})
   })
  }
}

export function getModalBlocks(page){
  const slug = {
    cartExtension: 'Extension-Modal',
    home: 'Homepage-Modal',
    cart: 'Cart-Modal',
    checkout: 'Checkout-Modal'
  }

  return function(dispatch) {
    dispatch({type: 'GET_MODAL_BLOCKS_FETCHING',});
    
    axios.get(apiUrl+'cms/blocks/'+slug[page]).then((response) => {
      if(page === 'cartExtension'){
        dispatch({type: 'GET_MODAL_EXTENSION_FULFILLED', payload: response.data,})
      }else{
        dispatch({type: 'GET_MODAL_BLOCKS_FULFILLED', payload: response.data,})
      }
    }).catch((err) =>{
      dispatch({type: 'GET_MODAL_BLOCKS_REJECTED', payload: err,})
    })
  }
}

export function resetCms(){
  return function(dispatch){
     dispatch({type: 'RESET_CMS',});
  }
}

export function closeModal(page) {
  return function(dispatch) {
    if (page === "cartExtension"){
      dispatch({type: 'HIDE_ADVISORY_EXTENSION_MODAL',page});
    }else{
      dispatch({type: 'HIDE_ADVISORY_MODAL',page});
    if (page === "cart"){
      localStorage.setItem("cartModalShowed", true)
    }
    if (page === "checkout"){
      localStorage.setItem("checkoutModalShowed", true)
    }
    }
  }
}

export function getCartBanner () {
  return function (dispatch) {
    axios.get(apiUrl + 'bnners?type=marketing_banner&status=1&category=cart&per_page=1').then((response) => {
      dispatch({ type: 'GET_CART_BANNER_FULFILLED', payload: response.data, })
    }).catch((err) => {
      dispatch({ type: 'GET_CART_BANNER_REJECTED', payload: err, })
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/CmsActions.js
 **/